module.exports = __webpack_public_path__ + "static/media/gen_img16.d998147a.png";